<template>
  <div class="default-layout">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <main class="main" :class="{ 'main--personal-cabinet': isCabinetRoute }">
        <button v-if="!isCabinetRoute" class="main__menu-trigger" @click="onShowMenu"></button>
        <transition name="fade" mode="out-in" @before-enter="scrollToTop">
          <router-view />
        </transition>
      </main>
      <app-menu v-if="!isCabinetRoute" :user="user" :class="{ 'menu--show': show_menu }" @closeMenu="onCloseMenu" />
    </template>
  </div>
</template>

<script>
import { isLoggedIn } from 'axios-jwt'
import { getMe, getPersonalCabinetMe } from '@/http'
import AppMenu from '@/components/AppMenu.vue'
import {
  PERSONAL_CABINET_ROLE,
  getIndexPageMobile,
  hasRole,
  isPersonalCabinetRoute,
  normalizeGroups,
} from '@/router/personalCabinet'

export default {
  components: { AppMenu },
  data() {
    return {
      is_loaded: false,
      user: null,
      show_menu: false,
      loadedContexts: {
        personalCabinet: false,
        work: false,
      },
    }
  },
  created() {
    if (!isLoggedIn()) return
    const indexPage = getIndexPageMobile(this.savedGroups)
    if (this.$route.name === 'base' && indexPage) {
      this.$router.replace({ name: indexPage }).catch(() => {})
      return
    }
    this.loadUserForRoute(this.$route)
  },
  watch: {
    '$route'(route, previousRoute) {
      this.onCloseMenu()
      this.loadUserForRoute(route)
      const currentRoot = route.matched[0]
      const previousRoot = previousRoute.matched[0]
      const sameRootView = currentRoot && previousRoot && currentRoot.path === previousRoot.path
      if (sameRootView && !isPersonalCabinetRoute(route)) this.$nextTick(this.scrollToTop)
    },
  },
  computed: {
    isCabinetRoute() {
      return isPersonalCabinetRoute(this.$route)
    },
    savedGroups() {
      return JSON.parse(localStorage.getItem('userGroups')) || []
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    loadUserForRoute(route) {
      const personalCabinet = isPersonalCabinetRoute(route)
      const context = personalCabinet ? 'personalCabinet' : 'work'
      const groups = normalizeGroups(this.savedGroups)
      const personalCabinetStart = isPersonalCabinetRoute(getIndexPageMobile(groups))

      const personalCabinetForbidden = !hasRole(groups, PERSONAL_CABINET_ROLE) && (groups.length > 0 || !personalCabinetStart)
      if (personalCabinet && personalCabinetForbidden) {
        this.is_loaded = true
        this.$router.replace({ name: 'access-denied' }).catch(() => {})
        return
      }
      if (this.loadedContexts[context]) {
        this.is_loaded = true
        return
      }

      this.is_loaded = false
      const request = personalCabinet ? getPersonalCabinetMe : getMe
      request()
        .then(response => {
          const data = response.data
          const responseGroups = data.groups || data.roles || data.user?.groups || data.employee?.groups
          const loadedGroups = normalizeGroups(responseGroups || this.savedGroups)

          if (personalCabinet && !hasRole(loadedGroups, PERSONAL_CABINET_ROLE)) {
            this.$router.replace({ name: 'access-denied' }).catch(() => {})
            return
          }

          this.user = data.user || data
          this.user.groups = loadedGroups
          this.$store.commit('setUserGroups', loadedGroups)
          if (personalCabinet) this.$store.commit('setPersonalCabinetData', data)
          else this.$store.commit('setUserData', data)
          this.loadedContexts[context] = true

          if (route.name === 'base') {
            this.$router.replace({ name: getIndexPageMobile(loadedGroups) || 'transfers' }).catch(() => {})
          }
        })
        .catch(() => {
          if (personalCabinet) this.$router.replace({ name: 'access-denied' }).catch(() => {})
        })
        .finally(() => {
          this.is_loaded = true
        })
    },
    onShowMenu() {
      this.show_menu = true
      document.body.classList.add('vm--block-scroll')
    },
    onCloseMenu() {
      document.body.classList.remove('vm--block-scroll')
      this.show_menu = false
    },
  }
}
</script>

<style lang="sass" scoped>
.default-layout
  flex-grow: 1
  display: flex

.main
  position: relative
  flex-grow: 1
  padding: 20px

.main--personal-cabinet
  min-width: 0
  padding: 0

.main__menu-trigger
  position: absolute
  right: 20px
  top: 20px
  width: 30px
  height: 30px
  background-image: url("~@/assets/img/menu-burger.svg")
  z-index: 99

.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
